function Uppercase({ input }) {

  return (
    <div className="output2">{input.toUpperCase()}</div>
  )
}

export default Uppercase;